import {getRoles} from '../../../services/AuthServices'

/**
 * Quyền của nhóm màn Định mức & sản lượng.
 *
 * Sáu quyền mà tài liệu đặt tên: `m16.config.view` · `m16.config.edit` · `m16.import` ·
 * `m17.report.view` · `m17.params.manage` · `m18.report.view`.
 *
 * Service ĐÃ tự kiểm tra quyền (T-B4 xong) — đó mới là lớp bảo vệ thật. Chặn ở giao diện chỉ để
 * không hiện nút mà bấm vào chắc chắn bị từ chối; đừng coi nó là lớp bảo vệ.
 *
 * ⚠️ Tài khoản FAC hiện chỉ mang danh sách role (`getRoles()` trả về mảng `{name}`), chưa mang
 *    scope dạng `m16.*`, nên ở đây vẫn suy quyền từ role `fac_admin`. Khi token mang scope thật
 *    thì đọc thẳng scope và bỏ suy diễn theo role.
 *
 * Route của nhóm màn này vào được bằng URL bất kể role (`Main.renderRoutes` không lọc `roles`) —
 * chấp nhận được vì service chặn: màn sẽ nhận 403 và `LoadError` hiện "Bạn không có quyền".
 */
const hasRole = (name) => (getRoles() || []).some((role) => role && role.name === name)

export const isFactoryAdmin = () => hasRole('fac_admin')

/** Sửa cấu hình định mức — quyết định ẩn nút và chuyển ô nhập sang chỉ đọc (M16 §5.3). */
export const canEditStandardConfig = () => isFactoryAdmin()

/** Nhập dữ liệu từ Excel (M16 §5.2 — không có quyền thì ẩn hẳn nút Import). */
export const canImportStandardConfig = () => isFactoryAdmin()

/**
 * Lưu tham số M17 và nhập số người / số máy đang có (P-04, P-05).
 * Không có quyền thì vẫn đổi thử được trong phiên xem, chỉ là không lưu (P-03).
 */
export const canManageWorkloadParams = () => isFactoryAdmin()

/**
 * Nhập / sửa giờ làm thực tế (FAC-26417 BR-1.3).
 *
 * ⚠️ `fac_ffm` CHỈ ĐỌC ở đây, và đó là khác biệt thật so với các màn còn lại chứ không phải sao chép
 *    `canEditStandardConfig` cho tiện: `PUT control/output/actual-hours` khai `@RequireRoles('fac_admin')`
 *    còn `GET` mở cho cả hai. Cho `fac_ffm` thấy ô nhập là cho họ gõ cả tuần rồi ăn 403 lúc bấm Lưu.
 */
export const canEditActualHours = () => isFactoryAdmin()
